import styled from '@emotion/styled'
import { size } from '@styles/theme'

import { PiArrowsClockwiseBold, PiChatCircleBold, PiLinkBold } from 'react-icons/pi'
import { ButtonBase } from '@mui/material'
import PostNumber from '../PostNumber'
import Heart from '../Heart'


const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: ${size(0.5)};
`

const ActionLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 60%;
`

const Action = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  color: grey;
  height: 100%;

  &::after {
    content: "";
    position: absolute;
    /* Expand the clickable area 12px outwards in all directions */
    top: -${size(1.75)};
    right: -${size(1.75)};
    bottom: -${size(1.75)};
    left: -${size(1.75)};
    // border-radius: 100px;
    // background-color: rgba(255,255,255, 0.5);
  }
`
const ActionText = styled.span`
  padding-left: ${size(0.25)};
  font-size: 12px;
`

const PostActionBar = ({ clickHandlers, stats, isReplyTop, media }) => {
  const { handleReplyClick, handleLikeClick, handleRepostClick, handleShareClick } = clickHandlers || {}
  const { likeCount, replyCount, repostCount, currentUserLiked } = stats || {}

  return (
    <ActionsContainer style={{
      paddingTop: media?.[0]?.uuid ? size(1.25) : size(0),
      paddingBottom: isReplyTop ? size(0.5) : size(1.35),
      }}>
      <ActionLeft>
        <Action onClick={handleReplyClick}>
          <PiChatCircleBold strokeWidth={2} fill='grey' size={size(2.1)} />
          <ActionText>
          <PostNumber value={replyCount} />
          </ActionText>
        </Action>
        <Action onClick={handleRepostClick}>
          <PiArrowsClockwiseBold strokeWidth={2} fill='grey' size={size(2.1)} style={{ transform: 'rotate(90deg)' }} />
          <ActionText>
          <PostNumber value={repostCount} />
          </ActionText>
        </Action>
        <Action onClick={handleLikeClick}>
          <Heart
            currentUserLiked={currentUserLiked}
            likeCount={likeCount}
          />
          <ActionText style={{ color: (currentUserLiked || 0) > 0 && '#FF007F' }} >
            <PostNumber value={likeCount} />
          </ActionText>
        </Action>
      </ActionLeft>
      <ButtonBase onClick={handleShareClick}>
        <PiLinkBold stroke='grey' fill='grey' size={size(2.1)} />
      </ButtonBase>
    </ActionsContainer>
  )
}

export { PostActionBar }
